import { NavLink } from "@/components/NavLink";
import { cn } from "@/lib/utils";

export interface SectionSubnavItem {
  label: string;
  to: string;
  end?: boolean;
}

interface SectionSubnavProps {
  title: string;
  items: SectionSubnavItem[];
}

export function SectionSubnav({ title, items }: SectionSubnavProps) {
  return (
    <div className="container px-2 pt-6">
      <div className="flex flex-col gap-4">
        <nav className="flex flex-wrap items-center gap-1 border-b border-border pb-3">
          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={cn(
                "px-3 py-2 rounded-md text-sm text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
              )}
              activeClassName="text-foreground bg-muted"
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
